<template>
    <v-row>
        <v-col>
            <v-card class="pa-4">
                <v-card-title>{{ entity.title }}</v-card-title>
                <v-card-text>
                    <CollectionTabLinks />
                    <v-row class="pl-3 pb-3" />
                    <v-row form class="form-group">
                        <v-col sm="3">Название</v-col>
                        <v-col sm="9">{{ entity.title }}</v-col>
                    </v-row>
                    <!-- <v-row form class="form-group">
                        <v-col sm="3">Привязанный домен</v-col>
                        <v-col sm="9"><a :href="`https://${ entity.host }`" v-if="entity.host" target="_blank">https://{{ entity.host }}</a></v-col>
                    </v-row> -->
                    <v-row form class="form-group">
                        <v-col sm="3">Адрес сайта доставки</v-col>
                        <v-col sm="9"><a :href="`${ siteLinkPreset }${ entity.code }`" target="_blank">{{ siteLinkPreset }}{{ entity.code }}</a></v-col>
                    </v-row>
                    <v-row form class="form-group">
                        <v-col sm="3">Картинка</v-col>
                        <v-col sm="9"><v-img width="300px" v-if="entity.picture" :src="imageSrc(entity.picture)" /></v-col>
                    </v-row>
                    <v-row form class="form-group">
                        <v-col sm="3">Заголовок</v-col>
                        <v-col sm="9" v-html="htmlFormatted(entity.description)"></v-col>
                    </v-row>
                    <v-row form class="form-group">
                        <v-col sm="3">Описание</v-col>
                        <v-col sm="9" v-html="htmlFormatted(entity.subdescription)"></v-col>
                    </v-row>
                    <v-row form class="form-group">
                        <v-col sm="3">Активен</v-col>
                        <v-col sm="9">
                            <span :class="`true-false-label ${getBadge(entity.enabled)}`">
                                &nbsp;{{entity.enabled ? 'Да' : 'Нет' }}&nbsp;
                            </span>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="pa-4 d-flex justify-space-between">
                    <div>
                        <v-btn
                            color="light"
                            class="mr-3"
                            @click="goBack"
                        >К списку</v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
    import store from '../../store';
    import { mapState } from 'vuex';
    import { yandexMap, ymapMarker } from 'vue-yandex-maps';
    import CollectionTabLinks from '../../components/collections/CollectionTabLinks';

    import { imageSrc, htmlFormatted } from '../../helpers';

    export default {
        name: 'CollectionDetail',

        components: {
            CollectionTabLinks,
            yandexMap, 
            ymapMarker
        },

        data() {
            return {
                imageSrc,
                htmlFormatted,
                mapZoom: 12,
                deleteModal: false,
            };
        },

        computed: {
            ...mapState('auth', ['user']),
            ...mapState('collections', {
                entity: state => state.entity
            }),
            ...mapState('siteTypes', {
                siteTypes: state => state.entities
            }),
            siteLinkPreset() {
                return `${ process.env.VUE_APP_FRONT_URL }/collection/`
            },
            isAdmin() {
                return this.user.admin;
            },
        },

        async mounted() {
            const id = this.$route.params.id;
            if(id) {
                await store.dispatch('collections/get', {id});
            }
        },

        methods: {
            getBadge (status) {
                return status ? 'success' : 'error';
            },
            goBack() {
                this.$router.push({ path: '/collections' });
            },
        },
    };
</script>

<style lang="scss">
    .entity_detail {
        &__map {
            width: 100%;
            height: 400px;

            &__wrapper {
                width: 100%;
                height: 400px;
                border-radius: 4px;
                overflow: hidden;
            }
        }
    }
</style>